export const WEBLATE_COMPONENT_NAME = 'business-center/business-center-client';
export const REGISTRATION_CACHE_KEY = 'registrationToken';
// Token response key is used by ionic-appauth to store the token response, this allows us to clear the token
export const TOKEN_RESPONSE = 'token_response';
export const MOBILE_PARTNER_ID = 'mobile-partner-id';
export const MOBILE_USER_EMAIL = 'mobile-user-email';
